export const darkExcludes = [
  '//member.bilibili.com/v2',
  '//member.bilibili.com/platform',
  '//member.bilibili.com/video/upload.html',
  '//member.bilibili.com/article-text/home',
  '//www.bilibili.com/audio/submit/',
  '//member.bilibili.com/studio/bs-editor/projects',
  '//www.bilibili.com/s/video/',
  '//member.bilibili.com/platform',
  // '//live.bilibili.com/p/html/live-lottery/', // 直播抽奖
  '//live.bilibili.com/web-cut/user-cut.html', // 直播剪辑
  '//account.bilibili.com/subtitle/edit/#/editor',
  // 创作中心-收益管理-充电计划
  '/york/allowance-charge',
  // 创作中心-收益管理-悬赏计划
  '//cm.bilibili.com/quests/#/task',
  '//live.bilibili.com/activity/live-activity-full/full-next/index.html',
  '//gf.bilibili.com/',
  '//shop.bilibili.com/',
  '//security.bilibili.com/', // SRC 安全中心 没人去适配
]
